import coffeeShopImage from '../images/liskov-journey/coffee-shop-animals.png'

const CoffeeShopImageComponent = () => {
    return (
        <div className='classroom-image-component'>
            <img src={coffeeShopImage} alt="Liskov classroom in cartoon form" />
        </div>
    );
};

export default CoffeeShopImageComponent;